const Retail = () => {
  return <h2>Retail</h2>;
};

export default Retail;
